import { Action } from '@ngrx/store';
import { IClientConfiguration } from '../../model';

// HTTP CRUD

//  CRUD
export enum ClientConfigurationActionsType {
  LOAD_HTTP = '[ClientConfiguration] Load Http',
  LOAD_HTTP_SUCCESS = '[ClientConfiguration] Load Http Success',
  LOAD_HTTP_FAIL = '[ClientConfiguration] Load Http Fail',

  ADD_HTTP = '[ClientConfiguration] Add Http',
  UPDATE_HTTP = '[ClientConfiguration] Update Http',
  ADD_UPDATE_HTTP_SUCCESS = '[ClientConfiguration] Add Update Http Success',
  ADD_UPDATE_HTTP_FAIL = '[ClientConfiguration] Add Update Http Fail',

  DELETE_HTTP = '[ClientConfiguration] Delete Http',
  DELETE_HTTP_SUCCESS = '[ClientConfiguration] Delete Http Success',
  DELETE_HTTP_FAIL = '[ClientConfiguration] Delete Http Fail',

  UPDATE_DATA_LENGTH = '[ClientConfiguration] Update Data Length',
  UPDATE_OFFSET = '[ClientConfiguration] Update Offset',
  UPDATE_LIMIT = '[ClientConfiguration] Update Limit',

  LOAD_PUBLIC_HTTP = '[ClientConfiguration] Load Public Http',
  LOAD_PUBLIC_HTTP_SUCCESS = '[ClientConfiguration] Load Http Public Success',
  LOAD_PUBLIC_HTTP_FAIL = '[ClientConfiguration] Load Public Http Fail',
}

export class LoadHttp implements Action {
  readonly type = ClientConfigurationActionsType.LOAD_HTTP;
  constructor(public payload: any) {}
}

export class LoadHttpSuccess implements Action {
  readonly type = ClientConfigurationActionsType.LOAD_HTTP_SUCCESS;
  constructor(public payload: IClientConfiguration[]) {}
}
export class LoadHttpFail implements Action {
  readonly type = ClientConfigurationActionsType.LOAD_HTTP_FAIL;
  constructor(public error: any) {}
}

export class AddHttp implements Action {
  readonly type = ClientConfigurationActionsType.ADD_HTTP;
  constructor(public payload: IClientConfiguration) {}
}

export class UpdateHttp implements Action {
  readonly type = ClientConfigurationActionsType.UPDATE_HTTP;
  constructor(public payload: IClientConfiguration) {}
}

export class AddUpdateHttpSuccess implements Action {
  readonly type = ClientConfigurationActionsType.ADD_HTTP;
  // comes from effect
  constructor(public payload: IClientConfiguration) {}
}
export class AddUpdateHttpFail implements Action {
  readonly type = ClientConfigurationActionsType.ADD_UPDATE_HTTP_FAIL;
  constructor(public error: any) {}
}

export class DeleteHttp implements Action {
  readonly type = ClientConfigurationActionsType.DELETE_HTTP;
  constructor(public clientConfigurationId: number) {}
}

export class DeleteHttpSuccess implements Action {
  readonly type = ClientConfigurationActionsType.DELETE_HTTP_SUCCESS;
  constructor(public payload: any) {}
}

export class DeleteHttpFail implements Action {
  readonly type = ClientConfigurationActionsType.DELETE_HTTP_FAIL;
  constructor(public error: any) {}
}

export class UpdateDataLength implements Action {
  readonly type = ClientConfigurationActionsType.UPDATE_DATA_LENGTH;
  constructor(public dataLength: number) {}
}

export class UpdateOffset implements Action {
  readonly type = ClientConfigurationActionsType.UPDATE_OFFSET;
  constructor(public offset: number) {}
}
export class UpdateLimit implements Action {
  readonly type = ClientConfigurationActionsType.UPDATE_LIMIT;
  constructor(public limit: number) {}
}
export class LoadPublicHttp implements Action {
  readonly type = ClientConfigurationActionsType.LOAD_PUBLIC_HTTP;
  constructor() {}
}

export class LoadPublicHttpSuccess implements Action {
  readonly type = ClientConfigurationActionsType.LOAD_PUBLIC_HTTP_SUCCESS;
  constructor(public payload: IClientConfiguration[]) {}
}
export class LoadPublicHttpFail implements Action {
  readonly type = ClientConfigurationActionsType.LOAD_PUBLIC_HTTP_FAIL;
  constructor(public error: any) {}
}
export type ClientConfigurationActions =
  | LoadHttp
  | LoadHttpSuccess
  | LoadHttpFail
  | AddHttp
  | UpdateHttp
  | AddUpdateHttpSuccess
  | AddUpdateHttpFail
  | DeleteHttp
  | DeleteHttpSuccess
  | DeleteHttpFail
  | UpdateDataLength
  | UpdateOffset
  | UpdateLimit
  | LoadPublicHttp
  | LoadPublicHttpSuccess
  | LoadPublicHttpFail;
